import { render, staticRenderFns } from "./BaseSheetEdit.vue?vue&type=template&id=b352e902&scoped=true&"
import script from "./BaseSheetEdit.vue?vue&type=script&lang=ts&"
export * from "./BaseSheetEdit.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSheetEdit.vue?vue&type=style&index=0&id=b352e902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b352e902",
  null
  
)

export default component.exports